const nameShorter = (word) =>
  word
    .split(" ")
    .map((word) => word[0])
    .join("");

export default nameShorter